import { Button, Group, Dialog } from '@economic/taco';
import React, { Dispatch, SetStateAction } from 'react';
import { t } from '~/app/shared/components/l10n/l10n';
import SmartPayOnboardingErrorContent from '../../SmartPayOnboardingErrorContent';

interface Props {
    errorCode: string;
    setErrorCode: Dispatch<SetStateAction<string | null>>;
    back: () => void;
    onDialogClose: () => void;
}

const ErrorStep = ({ errorCode, setErrorCode, back, onDialogClose }: Props) => {
    const onBackClicked = () => {
        setErrorCode(null);
        back();
    };

    return (
        <>
            <SmartPayOnboardingErrorContent errorCode={errorCode} />
            <Dialog.Footer>
                <Group>
                    <Button onClick={onBackClicked}>{t`SMARTPAY_ONBOARDING_MODAL_BACK_BUTTON`}</Button>
                    <Button autoFocus appearance="primary" onClick={onDialogClose}>
                        {t`SMARTPAY_ONBOARDING_MODAL_CONSENT_CLOSE_BUTTON`}
                    </Button>
                </Group>
            </Dialog.Footer>
        </>
    );
};

export default ErrorStep;
